import { useHead } from "@unhead/react"

const SITE_URL = "https://www.clips-on.ch"

interface SeoProps {
  title: string
  description: string
  path: string
  ogImage?: string
  ogType?: string
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
}

export default function Seo({
  title,
  description,
  path,
  ogImage = "https://static.lumi.new/18/18d4ccd0a29821be2cf88142236a9c64.webp",
  ogType = "website",
  jsonLd,
}: SeoProps) {
  const canonical = `${SITE_URL}${path}`
  const scripts = jsonLd
    ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map(item => ({
        type: "application/ld+json",
        innerHTML: JSON.stringify(item),
      }))
    : []

  useHead({
    htmlAttrs: { lang: "fr" },
    title,
    meta: [
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: canonical },
      { property: "og:type", content: ogType },
      { property: "og:site_name", content: "Clips'On" },
      { property: "og:locale", content: "fr_CH" },
      { property: "og:image", content: ogImage },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: title },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: ogImage },
    ],
    link: [
      { rel: "canonical", href: canonical },
    ],
    script: scripts,
  })

  return null
}

export { SITE_URL }
